// Copyright ©️ 2026 eVolve MEP, LLC

import { Badge, Group, Stack, Text, UnstyledButton } from '@mantine/core';

import { isNotNil } from 'helpers/isNotNil';

export const TaskGroupRow = ({
  label,
  selected,
  selectionCount,
  onClick,
  totalCount,
}: {
  label: string;
  selected: boolean;
  selectionCount?: number;
  onClick: () => void;
  totalCount?: number;
}) => (
  <UnstyledButton
    w="100%"
    px="md"
    py="xs"
    bg={selected ? 'gray.1' : undefined}
    onClick={onClick}
    aria-pressed={selected}
    style={{ borderRadius: 4 }}
  >
    <Group gap="xs" align="center" justify="space-between">
      <Stack gap={0} flex={1} miw={0}>
        <Text fz="sm" fw={500} lineClamp={1}>
          {label}
        </Text>
        {isNotNil(totalCount) && (
          <Text fz="xs" c="dimmed">
            {totalCount} task{totalCount === 1 ? '' : 's'}
          </Text>
        )}
      </Stack>
      {isNotNil(selectionCount) && selectionCount > 0 && (
        <Badge size="sm" radius="xl">
          {selectionCount}
        </Badge>
      )}
    </Group>
  </UnstyledButton>
);
